<template>
  <div class="page-writeof">
    <div class="writeof-item" v-if="info.id">
      <div class="item-top">
        <img :src="info.picUrl" alt="">
        <div class="item-name">
            {{info.name}}
            <div class="border-lb"></div>
            <div class="border-rt"></div>
          </div>
        <div class="item-level" v-if="info.level !== '-1'">
          <div class="level-h-line"></div>
          <div class="level-v-line-s"></div>
          <div class="level-v-line-l"></div>
          <div class="level-text">{{info.levelName}}</div>
          <div class="level-v-line-l"></div>
          <div class="level-v-line-s"></div>
          <div class="level-h-line"></div>
        </div>
      </div>
    </div>
    <div class="writeof-box">
      <div class="box-card today-reservation">
        <div class="card-title">今日已预约</div>
        <div class="card-num">{{info.bookingCnt || 0}}</div>
      </div>
      <div class="box-card today-writeof">
        <div class="card-title">今日已核销</div>
        <div class="card-num">{{info.verifiedCnt || 0 }}</div>
      </div>
    </div>
    <div class="writeof-btn btn-scan" role="button" @click="scan()">扫码核销</div>
    <div class="writeof-btn btn-input" role="button" @click="inputCode()">输入核销码</div>
    <mt-popup v-model="writeofVisiable" class="writeofpop">
      <h2>请输入核销码</h2>
      <input type="number" pattern="\d*" @input="verifyCode.length > 6 ? verifyCode=verifyCode.slice(0,6) : verifyCode" class="writeof-input" v-model.trim="verifyCode"/>
      <div class="writeof-btn btn-scan" role="button" @click="checkTicket()">核销</div>
      <div class="writeof-btn btn-input" role="button" @click="writeofVisiable = false">返回</div>
    </mt-popup>
    <div class="pop-status-box" v-show="statusVisiable">
      <div class="status-box">
        <div class="status-top-img">
          <img src="@/assets/images/chenggonghex@2x.png" v-show="resultCode === 2000">
          <img src="@/assets/images/shibaihexiao@2x.png" v-show="resultCode !== 2000">
        </div>
        <div class="status-text" v-show="resultCode === 2000 || resultCode === 5330">
          {{resultCode === 2000 ? '核销成功！' : '核销失败！'}}
        </div>
        <div class="status-text-error" v-show="resultCode > 5330">核销失败！</div>
        <div
          class="code-block block-green"
          v-show="resultCode === 2000">绿码</div>
        <div
          class="code-block block-red"
          v-show="resultCode === 5330">红码</div>
        <div
          class="status-reason"
          v-show="resultCode === 5330">
          {{writeOfResult.abnormalReason}}</div>
        <div class="status-reason" v-show="resultCode !== 2000">{{errorMessage}}</div>
        <div class="status-time" v-show="writeOfResult.rdate">
          预约时间：{{writeOfResult.rdate}} {{writeOfResult.time}}</div>
        <div class="status-name" v-show="writeOfResult.name">
          预约人：{{writeOfResult.name}}</div>
        <div class="status-box-close" role="button" @click="closeCheckpop()"></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { Toast, Indicator } from 'mint-ui'
let wx = require('weixin-js-sdk')
export default{
  data () {
    return {
      writeofVisiable: false,
      statusVisiable: false,
      resultCode: 2000,
      errorMessage: '请核对核销码/二维码！',
      writeOfResult: {},
      info: {},
      verifyCode: '',
      jsTicket: {}
    }
  },
  methods: {
    async getInfo () {
      let that = this
      try {
        let result = await that.$api({
          method: 'get',
          url: '/manage/bookingSite'
        })
        if (result.code === 2000 && result.result) {
          that.info = result.result
        } else {
          Toast({
            message: result.message,
            duration: 2000
          })
        }
      } catch (e) {
        Toast(e)
      }
    },
    async scan () {
      this.getJsticket()
    },
    async getJsticket () {
      let that = this
      if (that.jsTicket.appId) {
        wx.config({
          debug: false,
          appId: that.jsTicket.appId,
          timestamp: that.jsTicket.timestamp,
          nonceStr: that.jsTicket.nonceStr,
          signature: that.jsTicket.signature,
          jsApiList: ['scanQRCode']
        })
        wx.ready(function () {
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
              that.checkTicket(res.resultStr) // 当needResult 为 1 时，扫码返回的结果
            }
          })
        })
      } else {
        let signUrl = location.href.split('#')[0] // 获取分享的地址的前缀
        let jsTicket = await that.$api({
          method: 'post',
          url: '/wechat/getJsTicket',
          params: {
            signUrl: signUrl
          }
        })
        if (jsTicket.errorCode === '0') {
          wx.config({
            debug: false,
            appId: jsTicket.appId,
            timestamp: jsTicket.timestamp,
            nonceStr: jsTicket.nonceStr,
            signature: jsTicket.signature,
            jsApiList: ['scanQRCode']
          })
          wx.ready(function () {
            wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                that.checkTicket(res.resultStr) // 当needResult 为 1 时，扫码返回的结果
              }
            })
          })
          that.jsTicket = jsTicket
        } else {
          Toast('调用微信扫一扫失败')
        }
      }
    },
    async checkTicket (ticket) {
      let that = this
      try {
        Indicator.open()
        let result = await that.$api({
          method: 'post',
          url: '/manage/bookingSite/signIn',
          params: {
            id: that.info.id,
            verifyCode: ticket || that.verifyCode
          }
        })
        Indicator.close()
        that.resultCode = result.code
        that.writeOfResult = result.result || {}
        that.statusVisiable = true
        if (result.code !== 2000) {
          that.errorMessage = result.message
        } else {
          that.getInfo()
        }
      } catch (e) {
        Toast(e)
      }
    },
    inputCode () {
      this.verifyCode = ''
      this.writeofVisiable = true
    },
    closeCheckpop () {
      this.verifyCode = ''
      this.statusVisiable = false
    }
  },
  created () {
    this.getInfo()
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-writeof{
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #FFFFFF;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .writeof-btn{
    width: 1.55rem;
    text-align: center;
    line-height: .36rem;
    height: .36rem;
    border-radius: .18rem;
    font-size: .14rem;
    color: #FFFFFF;
    font-weight: bold;
  }
  .btn-scan{
    box-shadow: 0 2px 4px 0 rgba(67,107,196,0.50);
    background-image: linear-gradient(270deg, #6398FF 0%, #3F80FF 100%);
    margin-bottom: .2rem;
    margin-top: .87rem;
  }
  .btn-input{
    border: .01rem solid #7298FF;
    color: #5EA0FF;
    background: #FFFFFF;
  }
  .writeof-item{
    width: 100%;
    height: 1.85rem;
    background: #FFFFFF;
    box-shadow: 0 .02rem .04rem 0 rgba(0,0,0,0.16);
    border-radius: .04rem .04rem 0 0;
    overflow: hidden;
    .item-top{
      width: 100%;
      height: 1.85rem;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .item-name{
        margin-top: .47rem;
        min-width: 1.8rem;
        height: .3rem;
        line-height: .3rem;
        text-align: center;
        box-sizing: border-box;
        padding: 0 .13rem;
        background: rgba(0,42,83,.5);
        font-size: .16rem;
        color: #FFFFFF;
        font-weight: bold;
        position: relative;
        .border-lb{
          width: .83rem;
          height: .142rem;
          border-left: 1px solid rgba(236,240,255,0.67);
          border-bottom: 1px solid rgba(236,240,255,0.67);
          position: absolute;
          left: -.02rem;
          bottom: -.02rem;
        }
        .border-rt{
          width: .83rem;
          height: .142rem;
          border-right: 1px solid rgba(236,240,255,0.67);
          border-top: 1px solid rgba(236,240,255,0.67);
          position: absolute;
          top: -.02rem;
          right: -.02rem;
        }
      }
      .item-level{
        height: .2rem;
        display: flex;
        align-items: center;
        position: relative;
        margin-top: .06rem;
        .level-h-line{
          width: .37rem;
          height: 1px;
          background: rgba(255,255,255,1);
        }
        .level-v-line-s{
          width: .02rem;
          height: .06rem;
          background: #FFFFFF;
        }
        .level-v-line-l{
          width: .02rem;
          height: .1rem;
          background: #FFFFFF;
          margin-left: .02rem;
          ~.level-v-line-l{
            margin-right: .02rem;
          }
        }
        .level-text{
          box-sizing: border-box;
          padding: 0 .06rem;
          min-width: .63rem;
          font-size: .14rem;
          font-weight: bold;
          color: #FFFFFF;
          text-shadow: 0 2px 4px rgba(30,30,30,0.92);
        }
      }
    }
  }
  .writeof-box{
    margin-top: .15rem;
    width: 100%;
    height: .96rem;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 .15rem;
    .box-card{
      width: 1.67rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      box-sizing: border-box;
      padding-top: .22rem;
      padding-left: .78rem;
      .card-title{
        font-size: .14rem;
        line-height: .2rem;
        color: #FFFFFF;
        font-weight: bold;
      }
      .card-num{
        font-size: .21rem;
        color: #FFFFFF;
        line-height: .29rem;
        font-weight: bold;
        color: #FFFFFF;
        margin-top: .03rem;
      }
    }
    .today-reservation{
      background: url('../assets/images/4y@2x.png') no-repeat;
      background-size: 100% 100%;
    }
    .today-writeof{
      background: url('../assets/images/3y@2x.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  .writeofpop{
    width: 100%;
    height: 100%;
    background: url('../assets/images/hexioama-bg@2x.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    h2{
      font-size: .16rem;
      color: #666666;
      margin-top: 1.26rem;
    }
    .writeof-input{
      width: 3.45rem;
      height: .45rem;
      background: rgba(251,252,255,0.59);
      border: 1px solid #3A7FFF;
      border-radius: .225rem;
      outline: none;
      text-align: center;
      margin-top: .28rem;
      font-size: .24rem;
    }
    .btn-scan{
      margin-top: 1.62rem;
    }
  }
  .pop-status-box{
    width: 100%;
    height: 100%;
    background: rgba(48,48,48,.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    z-index: 2020;
    .status-box{
      margin-top: 1.33rem;
      width: 2.58rem;
      height: 2.98rem;
      border-radius: .072rem;
      background: url('../assets/images/tanc-bg@2x.png') no-repeat;
      background-color: #FFFFFF;
      background-size: 100% 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 0 .14rem;
      .status-box-close{
        width: .32rem;
        height: .32rem;
        position: absolute;
        left: 50%;
        margin-left: -.16rem;
        bottom: -.54rem;
        background: url('../assets/images/close2@2x.png') no-repeat;
        background-size: 100% 100%;
      }
      .status-top-img{
        width: .9rem;
        height: .85rem;
        position: absolute;
        top: -.19rem;
        left: .88rem;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .status-text{
        width: 100%;
        line-height: .26rem;
        font-size: .19rem;
        color: #666666;
        font-weight: bold;
        // padding-left: .88rem;
        text-align: center;
        margin-top: .76rem;
      }
      .status-text-error{
        width: 100%;
        line-height: .26rem;
        font-size: .19rem;
        color: #666666;
        font-weight: bold;
        padding-left: .88rem;
        margin-top: 1.01rem;
      }
      .code-block{
        width: 1.08rem;
        height: .36rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .14rem;
        color: #FFFFFF;
        margin: .08rem auto;
      }
      .block-green{
        background: #00BE26;
        margin-bottom: .35rem;
      }
      .block-red{
        background: #D13C3C;
      }
      .status-reason{
        font-size: .12rem;
        color: #333333;
        margin-top: .12rem;
        margin-bottom: .1rem;
        text-align: center;
      }
      .status-time{
        font-size: .14rem;
        color: #333333;
      }
      .status-name{
        font-size: .14rem;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WriteOf.vue